import {PricingConfig} from '@flexinet/pricing-components';
import {stage} from './stage.ts';

const platformApi: PricingConfig['platformApi'] = {
    prod: {
        endpoint: 'https://jerup2o5nzej3hnn2sdv3ejtca.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        applicationId: '8d803142-55c1-4c91-8911-8f56e5587fc6',
    },
    test: {
        endpoint: 'https://thz4u5ksajh6blvulnhiiddudi.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        applicationId: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
    },
    dev: {
        endpoint: 'https://4wbjzuqnxbfobbgd2bo4mjbj5e.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        applicationId: '70c8de3d-0b28-4450-89c9-8f7a4b3fec5c',
    },
    ide: {
        endpoint: 'https://4wbjzuqnxbfobbgd2bo4mjbj5e.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        applicationId: '70c8de3d-0b28-4450-89c9-8f7a4b3fec5c',
    },
};

export const publicPricingConfig: PricingConfig = {
    stage: stage,
    authMode: 'iam',
    pricingPageTitle: 'Flexi Email Service Plans',
    pricingPageSmallScript: 'Please note that these prices are subject to change. Actual prices may vary',
    platformApi,
};

export const authenticatedPricingConfig: PricingConfig = {
    stage: stage,
    authMode: 'userPool',
    pricingPageTitle: 'Flexi Email Service Plans',
    pricingPageSmallScript: 'Please note that these prices are subject to change. Actual prices may vary',
    platformApi,
};
